export const megaMenuData = {
    'send-receive': {
        columns: [
            [
                {
                    title: 'Отследить посылку',
                    description: 'Отслеживание статуса отправления и срока доставки',
                    href: '/tracking',
                },
              /*  {
                    title: 'Для маркетплейсов',
                    description: 'Доставка партий товаров на склады маркетплейсов (FBO/FBS)',
                    href: '/marketplace-delivery',
                },*/
                {
                    title: 'Профи',
                    description:
                        'Выгодный тариф для тех, что часто отправляет. Выбирайте тариф для отправки в своей упаковке',
                    href: '#',
                },
                {
                    title: 'CDEK ID',
                    description: 'Отправка и получение посылок без паспорта',
                    href: '#',
                },
                {
                    title: 'Наложка',
                    description:
                        'Безопасная сделка между физическими лицами. Вручим товар после его оплаты',
                    href: '#',
                },
                {
                    title: 'Упаковка',
                    description: 'Каталог упаковочных материалов и правила упаковки',
                    href: '#',
                },
                {
                    title: 'Передать паспортные данные для ТО',
                    description:
                        'Передать данные, необходимые для таможенного оформления международной посылки',
                    href: '#',
                },
                {
                    title: 'Опись вложения',
                    description:
                        'Отправляйте важные бумаги с юридическим подтверждением их числа и характера в суд, налоговую, визовые центры, офис от 85 ₽',
                    href: '#',
                    badge: 'NEW',
                },
            ],
            [
                {
                    title: 'Отправить посылку',
                    description: 'Рассчитайте и оформите накладную онлайн',
                    href: '/calculator',
                },
              /*  {
                    title: 'Доставка со своего склада',
                    description: 'Доставка единичных заказов с вашего склада конечному покупателю',
                    href: '/dbs',
                },*/
                { title: 'Тарифы', description: 'Подробная информация о тарифах', href: '#' },
                {
                    title: 'Программа лояльности',
                    description: 'Пользуйтесь услугами СДЭК и копите баллы. Вернем до 10% от чека.',
                    href: '#',
                },
                {
                    title: 'Онлайн-оплата',
                    description: 'Онлайн-оплата услуг картой или через СБП',
                    href: '#',
                },
                {
                    title: 'Возврат',
                    description: 'Услуга по возврату товаров в интернет-магазин',
                    href: '#',
                },
                {
                    title: 'Международные отправки',
                    description: 'Международные отправления для стран присутствия',
                    href: '#',
                },
                {
                    title: 'Доставка за 4 часа',
                    description: 'Доставим вашу посылку за 4 часа внутри города',
                    href: '#',
                    badge: 'NEW',
                },
            ],
        ],
    },
    services: {
        columns: [],
    },
};

export const mobileNavData = [
    {
        title: 'Частным лицам',
        items: [
            {
                title: 'Сервисы и продукты',
                hasSubmenu: true,
                submenuItems: megaMenuData['send-receive'].columns.flat(),
            },
            { title: 'Отследить посылку', href: '/tracking' },
            { title: 'Калькулятор доставки', href: '/calculator' },
            { title: 'Тарифы', href: '#' },
        ],
    },
    {
        title: 'Бизнесу',
        items: [
            { title: 'Отследить отправление', href: '#' },
            { title: 'Тарифы', href: '#' },
            { title: 'Продукты', hasSubmenu: true, submenuItems: [] },
            { title: 'Франшиза', href: '#' },
            { title: 'Документация', href: '#' },
            { title: 'Заключить договор', href: '#' },
        ],
    },
    {
        title: 'Интернет-магазинам',
        items: [
            { title: 'Интеграция', href: '#' },
            { title: 'Тарифы', href: '#' },
        ],
    },
];
